import { CONFIRM_EMAIL_STATUS, GENDER, STATUS, STEP_STATUS, TOOL_CERTIFICATE_TYPE, WORK_FORM, ORDER_STATUS, OrderStatus } from '@shared/types/enums';

// #region Status
export const STATUS_CONFIG = {
    [STATUS.Active]: {
        value: STATUS.Active,
        name: '有効'
    },
    [STATUS.Inactive]: {
        value: STATUS.Inactive,
        name: '無効'
    }
};

export const STATUS_CONFIG_LIST = [
    {
        value: STATUS.Active,
        name: '有効'
    },
    {
        value: STATUS.Inactive,
        name: '無効'
    }
];
// #endregion Status;

export const STATUS_STEP_CONFIG = {
    [STEP_STATUS.DISABLE]: {
        value: STEP_STATUS.DISABLE,
        bgColor: 'bg-[#EDF8F3]',
        textColor: 'text-black',
        color: '#EDF8F3'
    },
    [STEP_STATUS.ACTIVE]: {
        value: STEP_STATUS.ACTIVE,
        bgColor: 'bg-[#373737]',
        textColor: 'text-white',
        color: '#373737'
    },
    [STEP_STATUS.PASS]: {
        value: STEP_STATUS.DISABLE,
        bgColor: 'bg-[#09AA6E]',
        textColor: 'text-white',
        color: '#09AA6E'
    }
};

export const PREFECTURES = [
    '北海道',
    '青森県',
    '岩手県',
    '宮城県',
    '秋田県',
    '山形県',
    '福島県',
    '茨城県',
    '栃木県',
    '群馬県',
    '埼玉県',
    '千葉県',
    '東京都',
    '神奈川県',
    '新潟県',
    '富山県',
    '石川県',
    '福井県',
    '山梨県',
    '長野県',
    '岐阜県',
    '静岡県',
    '愛知県',
    '三重県',
    '滋賀県',
    '京都府',
    '大阪府',
    '兵庫県',
    '奈良県',
    '和歌山県',
    '鳥取県',
    '島根県',
    '岡山県',
    '広島県',
    '山口県',
    '徳島県',
    '香川県',
    '愛媛県',
    '高知県',
    '福岡県',
    '佐賀県',
    '長崎県',
    '熊本県',
    '大分県',
    '宮崎県',
    '鹿児島県',
    '沖縄県'
];

export const WORK_TYPE = {
    // 保険薬局,
    USER_DISPENSING_PHARMACY: '保険薬局',
    // Dgs
    USER_DGS: 'Dgs',
    // 病院
    USER_HOSPITAL: '病院',
    // 製薬企業
    USER_PHARMACEUTICAL_COMPANIES: '製薬企業',
    // 卸
    USER_WHOLESALER: '卸',
    // その他
    USER_OTHERS: 'その他'
};

export const GENDER_CONFIG = {
    [GENDER.Male]: {
        value: GENDER.Male,
        label: '男性'
    },
    [GENDER.Female]: {
        value: GENDER.Female,
        label: '女性'
    }
};

export const LIST_GENDER_OPTIONS = Object.keys(GENDER_CONFIG).map(key => GENDER_CONFIG[key]);

export const WORK_FORM_CONFIG = {
    [WORK_FORM.OFFSHORE]: {
        label: '沖',
        value: WORK_FORM.OFFSHORE
    },
    [WORK_FORM.OUTSIDE]: {
        label: '外',
        value: WORK_FORM.OUTSIDE
    },
    [WORK_FORM.OTHER]: {
        label: '選択なし',
        value: WORK_FORM.OTHER
    }
};

export const LIST_WORK_FORM_OPTIONS = Object.keys(WORK_FORM_CONFIG).map(key => WORK_FORM_CONFIG[key]);

export const TOOL_CERTIFICATE_TYPE_OPTIONS = {
    [TOOL_CERTIFICATE_TYPE.NEW]: {
        label: '新規',
        value: TOOL_CERTIFICATE_TYPE.NEW,
        duration: 4
    },
    [TOOL_CERTIFICATE_TYPE.UPDATE]: {
        label: '更新',
        value: TOOL_CERTIFICATE_TYPE.UPDATE,
        duration: 3
    }
};

export const LIST_TOOL_CERTIFICATE_TYPE_OPTIONS = Object.keys(TOOL_CERTIFICATE_TYPE_OPTIONS).map(key => TOOL_CERTIFICATE_TYPE_OPTIONS[key]);

export const CONFIRM_EMAIL_CONFIG = {
    [CONFIRM_EMAIL_STATUS.CONFIRM_EMAIL_SUCCESS]: {
        label: 'メールアドレスが更新されました。これからは、新しいメールアドレスでログインして、システムを使用できます。',
        value: CONFIRM_EMAIL_STATUS.CONFIRM_EMAIL_SUCCESS
    },
    [CONFIRM_EMAIL_STATUS.CONFIRM_EMAIL_NOT_EXISTED_OR_EXPIRED_OR_ALREADY_CONFIRM]: {
        label: 'このリンクは有効期限が切れているか、すでに使用されています。',
        value: CONFIRM_EMAIL_STATUS.CONFIRM_EMAIL_NOT_EXISTED_OR_EXPIRED_OR_ALREADY_CONFIRM
    },
    [CONFIRM_EMAIL_STATUS.CONFIRM_EMAIL_ALREADY_USE]: {
        label: 'このメールアドレスはすでに別のアカウントで使用されています。新しいメールアドレスを更新してください。',
        value: CONFIRM_EMAIL_STATUS.CONFIRM_EMAIL_ALREADY_USE
    }
};

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
    [ORDER_STATUS.NOT_PAID]: '支払い待ち',
    [ORDER_STATUS.PAID]: '支払済',
    [ORDER_STATUS.FAILURE]: '支払い待ち'
};

export const ORDER_STATUS_COLORS: Record<OrderStatus, string> = {
    [ORDER_STATUS.NOT_PAID]: 'bg-[#FFF4BE] text-[#FBBC04]',
    [ORDER_STATUS.PAID]: 'bg-[#BEFFD3] text-[#09AA6E]',
    [ORDER_STATUS.FAILURE]: 'bg-[#FFF4BE] text-[#FBBC04]'
};
